<template>
	<VInput
		ref="company-uscc-input"
		v-model="company.additionalAttributes.mwstTvaIva.value"
		:label="company.additionalAttributes.mwstTvaIva.name"
		layout="vertical"
		:validate-method="CnUtils.validateUSCC"
		:disabled="readOnly"
	/>
</template>

<script>

import CnUtils 									from "@/core/utils/regional/CnUtils";
import Company from "@/domains/Companies/Company.js";

export default {
	name:   'CHAdditionalAttributes',

	props: {
    company: {
      type:     Company,
      required: true
    },
		readOnly: {
			type: Boolean,
			default: false,
		}
	},

	data() {
		return {
			CnUtils,
		}
	},
};
</script>
